import { useFormContext } from 'react-hook-form'

import { RadioButton } from '../baseInputs'

type Option = {
  label: string
  value: string
}

type Props = {
  name: string
  question: string
  options: Option[]
}

const CompetitionQuestion = ({ name, question, options }: Props) => {
  const { formState, getFieldState } = useFormContext()
  const { error } = getFieldState(name, formState)

  return (
    <div>
      <p className="font-medium my-5">{question}</p>
      <div className="radio-btn-container flex flex-col gap-2 mb-5">
        {options.map((option) => (
          <RadioButton
            key={option.value}
            name={name}
            label={option.label}
            value={option.value}
            errorDisabled
          />
        ))}
        {error && (
          <p className="text-red text-tiny mt-1" role="alert">
            {error.message}
          </p>
        )}
      </div>
    </div>
  )
}

export default CompetitionQuestion
